// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b05e4bb1","977":"33c877e2"}[chunkId] + ".chunk.js";
};